import React from 'react'

const COLORS = [
  { bg:'#dbeafe', border:'#3b82f6', text:'#1e40af' },
  { bg:'#dcfce7', border:'#22c55e', text:'#15803d' },
  { bg:'#fef9c3', border:'#eab308', text:'#854d0e' },
  { bg:'#fce7f3', border:'#ec4899', text:'#9d174d' },
  { bg:'#ede9fe', border:'#8b5cf6', text:'#5b21b6' },
]

function timeToMinutes(t) {
  if (!t) return Infinity
  const [hm, ap] = t.split(' ')
  let [h, m] = hm.split(':').map(Number)
  if (ap === 'PM' && h !== 12) h += 12
  if (ap === 'AM' && h === 12) h = 0
  return h * 60 + (m || 0)
}

export default function PlanDelDiaPrint({ date, teams, clients, staff, onClose }) {
  const dayLabel = new Date(date+'T12:00:00').toLocaleDateString('es-MX', { weekday:'long', day:'numeric', month:'long', year:'numeric' })

  function clientInfo(clientId) {
    return clients.find(c=>c.id===clientId)
  }
  function staffNames(ids) {
    return (ids||[]).map(id => staff.find(s=>s.id===id)?.name).filter(Boolean)
  }

  const teamsWithJobs = teams
    .map((team, ti) => ({ team, ti, jobs: [...team.jobs].sort((a,b)=>timeToMinutes(a.time)-timeToMinutes(b.time)) }))
    .filter(t => t.jobs.length > 0)

  return (
    <div style={ov.overlay} className="pdp-overlay">
      <style>{`
        @media print {
          body * { visibility: hidden; }
          .pdp-printarea, .pdp-printarea * { visibility: visible; }
          .pdp-printarea { position: absolute; left: 0; top: 0; width: 100%; }
          .pdp-noprint { display: none !important; }
          .pdp-team { page-break-inside: avoid; }
        }
      `}</style>
      <div style={ov.modal}>
        <div style={ov.header} className="pdp-noprint">
          <div style={{fontSize:16,fontWeight:700}}>🖨️ Plan del día — para imprimir</div>
          <div style={{display:'flex',gap:8}}>
            <button style={ov.printBtn} onClick={()=>window.print()}>🖨️ Imprimir</button>
            <button style={ov.closeBtn} onClick={onClose}>×</button>
          </div>
        </div>

        <div style={ov.body} className="pdp-printarea">
          <div style={{textAlign:'center',marginBottom:28}}>
            <div style={{fontSize:22,fontWeight:800,color:'#202124'}}>🐈 Kitty's Cleaning Services</div>
            <div style={{fontSize:16,color:'#5f6368',marginTop:4,textTransform:'capitalize'}}>{dayLabel}</div>
          </div>

          {teamsWithJobs.length===0 ? (
            <div style={{textAlign:'center',color:'#9aa0a6',padding:40,fontSize:14}}>Sin rutas armadas todavía para este día.</div>
          ) : teamsWithJobs.map(({team, ti, jobs}) => {
            const col = COLORS[ti % COLORS.length]
            const names = staffNames(team.staffIds)
            return (
              <div key={ti} className="pdp-team" style={{marginBottom:26,border:`2px solid ${col.border}`,borderRadius:12,overflow:'hidden'}}>
                <div style={{background:col.bg,padding:'10px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <div style={{fontSize:17,fontWeight:800,color:col.text}}>Ruta {ti+1}</div>
                  <div style={{fontSize:13,fontWeight:600,color:col.text}}>{names.length?names.join(' + '):'Sin asignar'}</div>
                </div>
                <div style={{padding:'6px 0'}}>
                  {jobs.map((job,i) => {
                    const cl = clientInfo(job.clientId)
                    const address = cl?.address ? `${cl.address}${cl.city?', '+cl.city:''}` : ''
                    return (
                      <div key={i} style={{padding:'12px 18px',borderTop:i>0?'1px solid #f0f0f0':'none',display:'flex',gap:14,alignItems:'flex-start'}}>
                        <div style={{fontSize:15,fontWeight:700,color:'#80868b',minWidth:78,flexShrink:0}}>{job.time||'Todo el día'}</div>
                        <div style={{flex:1}}>
                          <div style={{fontSize:17,fontWeight:700,color:'#202124'}}>{cl?.nickname||cl?.name||'?'}</div>
                          {address && <div style={{fontSize:13,color:'#80868b',marginTop:1}}>{address}</div>}
                          {job.notes && <div style={{fontSize:13,color:'#c05070',marginTop:3}}>📝 {job.notes}</div>}
                        </div>
                        <div style={{fontSize:14,fontWeight:600,color:'#80868b',flexShrink:0}}>{job.hours}h</div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const ov = {
  overlay: {position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:400,display:'flex',alignItems:'center',justifyContent:'center'},
  modal: {background:'#fff',borderRadius:14,width:'94vw',maxWidth:820,maxHeight:'92vh',display:'flex',flexDirection:'column',overflow:'hidden',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'},
  header: {display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 20px',borderBottom:'1px solid #e3e5e8',flexShrink:0},
  printBtn: {padding:'8px 16px',border:'none',borderRadius:8,background:'#e8547a',color:'#fff',fontWeight:600,fontSize:13,cursor:'pointer'},
  closeBtn: {fontSize:22,border:'none',background:'none',cursor:'pointer',color:'#9aa0a6'},
  body: {overflowY:'auto',padding:'24px 28px'},
}
